import React from 'react'
import {Link} from 'react-router-dom'
import getDate from 'utils/get-date'
import defaultThumb from 'assets/img/defaults/default-thumbnail.jpg'
// import VideoModal from '../../shared/Modal'

const HomeUpdatesV2 = props => {
  const comUpdates = props.partner.com_updates
  if (comUpdates === undefined || comUpdates === null) {
    return <h5>Updates not available</h5>
  }

  return (
    <div className="homeupdates">
      <h2 className='mb-2'>My Updates</h2>
      <img className="img-responsive mb-2" src={props.partner.community_updates || defaultThumb} alt="wv"/>
      <Link to="/dashboard/my-updates" className="btn">See more updates</Link>
    </div>
  )
}

export default HomeUpdatesV2
